import ApiConfig from "../config/Api.config";
import Data from "../data/Api.data";
import Reclamo from "../interfaces/Reclamo.interface";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";
// import UsuarioModel from "../models/Usuario.model";

const urlSinergia: string = `${Data.URLS.urlApiSinergia}/reclamo`

const listar = async (fechaInicial: string, fechaFinal: string) => {
    const request: Request = {
        url: `${urlSinergia}/listar`,
        method: "POST",
        data: { fechaInicial, fechaFinal }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const guardar = async (reclamo: Reclamo) => {
    const request: Request = {
        url: `${urlSinergia}/guardar`,
        method: "POST",
        data: { reclamo }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const eliminar = async (IdReclamacion: number) => {
    const request: Request = {
        url: `${urlSinergia}/eliminar/${IdReclamacion}`,
        method: "DELETE",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const ReclamoService = {
    listar,
    guardar,
    eliminar
}

export default ReclamoService;